import moment from 'moment';

export class DueDateFilterUtil {
  static getDueDateQuery(dueDateFilter) {
    const todaysDate = moment().format('YYYY-MM-DD');
    let dueDateQuery = null;
    switch (dueDateFilter) {
      case 'pending':
        dueDateQuery = `all_before_due=${todaysDate}`;
        break;
      case 'overdue':
        dueDateQuery = `all_past_due=${todaysDate}`;
        break;
      case 'ascending':
        dueDateQuery = 'due_asc=true';
        break;
      case 'descending':
        dueDateQuery = 'due_desc=true';
        break;
      default:
    }
    return dueDateQuery;
  }
}



// WEBPACK FOOTER //
// ./src/services/utils/due-date-filter-util.js